/* eslint-disable no-nested-ternary */
import {Divider} from "@mui/material"
import {styled} from "@mui/material/styles"
import {breakpoints, FALLBACK_FONT_FAMILY} from "@next/ux-fabric"
import {XXL_BREAKPOINT_MAX} from "../../config/constants"

export const BannerContainer = styled("div", {
    shouldForwardProp: prop => !["showStaticBanner", "backgroundColor"].includes(prop as any),
})<{showStaticBanner: boolean; backgroundColor: string}>`
    height: 2.25rem;
    min-height: 2.25rem;
    background: ${({theme, backgroundColor}) =>
        backgroundColor || theme.uxfabric.components.appBar.globalBar.default.backgroundColor};
    width: 100%;
    @media (max-width: ${breakpoints.values.md}px) {
        display: ${({showStaticBanner}) => (showStaticBanner ? "flex" : "none")};
    }
    @media (min-width: ${breakpoints.values.md}px) {
        display: flex;
    }
    justify-content: center;
`

export const BannerInnerContainer = styled("div")`
    display: flex;
    align-items: center;
    margin-left: auto;
    max-width: ${breakpoints.values.xl}px;
    justify-content: space-between;

    padding: 0 0.25rem 0 1rem;

    @media (min-width: ${breakpoints.values.md}px) {
        padding: 0rem 2.063rem 0rem 2rem;
    }

    @media (min-width: ${breakpoints.values.lg}px) {
        padding: 0rem 2rem 0rem 2rem;
    }

    @media (min-width: ${breakpoints.values.xl}px) {
        padding: 0rem 1.25rem 0rem 2.5rem;
    }
`
export const BannerLink = styled("a")`
    color: ${({theme}) => theme.uxfabric.components.appBar.globalBar.default.textColor};
    text-decoration: none;
    font-size: ${({theme}) => theme.uxfabric.global.body4.fontSize};
    font-weight: ${({theme}) => theme.uxfabric.global.body4.fontWeight};
    font-family: ${({theme}) => theme.uxfabric.global.body4.fontFamily}, ${FALLBACK_FONT_FAMILY} !important;
`
export const BannerPromoText = styled("span")`
    color: ${({theme}) => theme.uxfabric.components.appBar.globalBar.default.textColor};
    text-decoration: none;
    font-size: ${({theme}) => theme.uxfabric.global.body4.fontSize};
    font-weight: ${({theme}) => theme.uxfabric.global.body4.fontWeight};
`
export const QuickLinksContainer = styled("div")`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    gap: 0.938rem;
    @media (max-width: ${breakpoints.values.md}px) {
        display: none;
    }
    @media (min-width: ${breakpoints.values.md}px) {
        display: flex;
        height: 100%;
        align-items: center;
    }
`
export const QuickLinkContainer = styled("div")`
    display: flex;
    z-index: 1;
`

export const QuickLinkDivider = styled(Divider)`
    height: 1.25rem;
    border-color: ${({theme}) => theme.uxfabric.components.appBar.globalBar.default.divider.default.borderColor};
`
export const ContentBannerContainer = styled("div")`
    padding: 0 2.5rem 0 2.5rem;

    @media (max-width: ${breakpoints.values.lg}px) {
        padding: 0 2rem 0 2rem;
    }
`
export const MessageBannerWrapper = styled("div", {
    shouldForwardProp: prop => !["xxlBreakpointEnabled"].includes(prop as any),
})<{xxlBreakpointEnabled: boolean}>`
    position: absolute;
    align-items: center;
    max-width: ${({xxlBreakpointEnabled}) => (xxlBreakpointEnabled ? XXL_BREAKPOINT_MAX : breakpoints.values.xl)}px;
    width: 100%;
`
